<template>
    <div class="tc-item-counter">
        <div class="tc-item-counter-button"
             :class="{'tc-item-counter-button-disabled': number <= minValue}"
             @click.stop="decreaseNumber()">
            -
        </div>
        <input class="tc-item-counter-input"
               :value="number"
               @change="setNumber($event.target.value)">
        <div class="tc-item-counter-button"
             :class="{'tc-item-counter-button-disabled': number >= maxValue}"
             @click.stop="increaseNumber()">
            +
        </div>
    </div>
</template>

<script>
export default {
    name: 'ItemCounter',
    props: [
        'number',
        'minValue',
        'maxValue',
    ],
    emits: [
        'change',
        'decrease',
        'increase',
    ],
    methods: {
        setNumber(val) {
            if (val < this.minValue) {
                this.$emit('change', this.minValue);
            } else if (val > this.maxValue) {
                this.$emit('change', this.maxValue);
            } else {
                this.$emit('change', val);
            }
        },
        decreaseNumber() {
            if (this.number <= this.minValue) {
                return;
            }
            this.$emit('decrease');
        },
        increaseNumber() {
            if (this.number >= this.maxValue) {
                return;
            }
            this.$emit('increase');
        },
    },
};
</script>

<style scoped lang="scss">
.tc-item-counter {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    height: max-content;
    width: max-content;
    gap: 2px;
}

.tc-item-counter-button {
    height: 20px;
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #00458D;
    border: 1px solid currentColor;
    vertical-align: center;
    box-sizing: border-box;
    cursor: pointer;
    user-select: none;
    transition: 0.3s ease all;
}

.tc-item-counter-button:active {
    color: #0170E3;
}

.tc-item-counter-button-disabled {
    color: #33333380 !important;
    border-color: #D9D9D9 !important;
}

.tc-item-counter-input {
    color: #333333;
    border: 1px solid #D9D9D9;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 20px;
    width: 42px;
    outline: none;
    padding: 2px;
    box-sizing: border-box;
    margin: 0;

}

</style>
